import { generateThemeOverride } from '@botpress/webchat'
import { LatestWebchatTheme } from '@bpinternal/shared'
import { ReactNode, useMemo, useState } from 'react'
import { cn } from '~/utils'

type WebchatComponentPreviewProps = {
  theme?: LatestWebchatTheme
  children: ReactNode
  className?: string
}

let instanceCounter = 0

export const WebchatComponentPreview: React.FC<WebchatComponentPreviewProps> = ({
  theme,
  children,
  className,
}: WebchatComponentPreviewProps) => {
  const [instanceId] = useState(() => instanceCounter++)

  const styleTag = useMemo(() => {
    const themeOverride = generateThemeOverride({ ...theme })

    const cssVars = Object.entries(themeOverride)
      .map(([key, value]) => `${key}: ${value};`)
      .join('\n    ')

    // Generates a unique instance ID for each preview component to create isolated scopes
    // Creates a scoped style tag that targets `.preview-{instanceId} .bpReset`
    return `.preview-${instanceId} .bpReset { ${cssVars} }`
  }, [theme, instanceId])

  return (
    <>
      <style>{styleTag}</style>
      <div className={cn('w-full overflow-clip', `preview-${instanceId}`, className)}>{children}</div>
    </>
  )
}

export default WebchatComponentPreview
